/**
 * @module Experince/Product-Selector
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */
/** */
import {
  LineDeivceDetails,
  lineTypeEnum,
} from '@experience/shop/product-selector/interfaces/product-selector.interface';
import { ObjectService } from '@support/state-object-hash-utilities/services/object.service';

export class IsLineSetupCompletedModel {
  constructor() {}

  /**
   * Function used to check if line setup is completed.
   * @param {LineDeviceDetails} currentLineDetails
   * @param {ObjectService} objectService
   * @returns {boolean}
   */
  public static isLineSetupCompleted(
    currentLineDetails: LineDeivceDetails,
    objectService: ObjectService
  ): boolean {
    const cartResponse = !!(
      objectService.get(currentLineDetails, 'plansFromCart.planOfferName') ||
      objectService.get(currentLineDetails, 'noPlanNeeded')
    );
    const isSimDeviceSelected = !!(
      objectService.get(currentLineDetails, 'byodSimData') ||
      !!objectService.get(currentLineDetails, 'selectedDevice')
    );
    if (objectService.get(currentLineDetails, 'lineTileType') === lineTypeEnum.EXISTING) {
      return true;
    } else {
      return cartResponse && isSimDeviceSelected;
    }
  }
}
